module.exports = __webpack_public_path__ + "static/media/WCV.bda5c389.jpg";